const RowLoader = ({ paddingStyle = "tw-py-4", size = "tw-w-6 tw-h-6" }) => (
  <tr>
    <td colSpan="100%" className={`tw-text-center ${paddingStyle}`}>
      <div
        className={`${size} tw-border-4 tw-border-gray-300 tw-border-t-blue-500 tw-rounded-full tw-animate-spin`}
      ></div>
    </td>
  </tr>
);
export default RowLoader;
